// assets
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// ==============================|| COMPRA IGLESIA MENU ITEMS ||============================== //

const compraIglesia = {
    id: 'compraIglesia',
    type: 'group',
    children: [
        {
            id: 'compraIglesiaItem',
            title: 'Compra Iglesia',
            type: 'item',
            url: '/CompraIglesia/Lista',
            icon: AccountBalanceIcon,
            breadcrumbs: false
        }
    ]
};

export default compraIglesia;
